import Vue from 'vue'
import Vuex from 'vuex'

import { warning } from 'hey-listen'

Vue.use(Vuex)

import { validScenes } from '@/util/sceneMap'

export default new Vuex.Store({
    state: {
        scene: 'landing',
        clickedScene: null,
        layout: 'vertical',
        w: window.innerWidth || 360,
        h: window.innerHeight || 640,
        showSignUp: false,
        signUpText: ''
    },
    mutations: {
        setScene(state, nextScene) {
            if (validScenes.includes(nextScene)) {
                state.scene = nextScene
            } else {
                warning(false, `${nextScene} is not a valid scene!`)
            }
        },
        setSize(state, { width, height }) {
            // set the size
            state.w = width
            state.h = height
            // set the layout
            // note: there is the potential for more layouts
            state.layout = state.w > state.h ? 'horizontal' : 'vertical'
        },
        clickScene(state, scene) {
            state.clickedScene = scene
        },
        openSignUp(state, text) {
            state.showSignUp = true
            state.signUpText = text
        },
        closeSignUp(state) {
            state.showSignUp = false
        }
    }
})
